import { FeedbackDetailsHeaderCloseIcon } from '@modules/feedback/components/FeedbackDetails/FeedbackDetailsHeader/FeedbackDetailsHeaderCloseIcon';
import { FeedbackDetailsHeaderRightActions } from '@modules/feedback/components/FeedbackDetails/FeedbackDetailsHeader/FeedbackDetailsHeaderRightActions';
import { FeedbackDetailsHeaderSourceDetail } from '@modules/feedback/components/FeedbackDetails/FeedbackDetailsHeader/FeedbackDetailsHeaderSourceDetail';
import { Paper, Stack } from '@mui/material';
import { Feedback } from 'v2/core/entities/feedback';

interface FeedbackDetailsHeaderProps {
  feedback: Feedback;
  onDrawerClose?: () => void;
  sourceV2: Feedback['sourceV2'];
  setCurrentFeedbackIndex?: (index: number) => void;
  setCurrentFeedback?: (feedback: Feedback) => void;
  feedbacks?: Feedback[];
  currentFeedbackIndex?: number;
  totalRecords?: number;
  isLoadingMore?: boolean;
}

export const FeedbackDetailsHeader = ({
  feedback,
  onDrawerClose,
  sourceV2,
  setCurrentFeedback = (feedback: Feedback) => {},
  setCurrentFeedbackIndex = (index: number) => {},
  feedbacks = [],
  currentFeedbackIndex = 0,
  totalRecords = 0,
  isLoadingMore,
}: FeedbackDetailsHeaderProps) => {
  return (
    <>
      <Paper
        elevation={0}
        sx={{
          borderRadius: 0,
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Stack
          p={2}
          justifyContent="space-between"
          direction="row"
          alignItems="center"
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <FeedbackDetailsHeaderCloseIcon
              feedbackID={feedback.id}
              onDrawerClose={onDrawerClose}
            />
            <FeedbackDetailsHeaderSourceDetail
              feedback={feedback}
              sourceV2={sourceV2}
              isLoadingMore={isLoadingMore}
            />
          </Stack>
          <FeedbackDetailsHeaderRightActions
            feedback={feedback}
            onDrawerClose={onDrawerClose}
            setCurrentFeedback={setCurrentFeedback}
            setCurrentFeedbackIndex={setCurrentFeedbackIndex}
            feedbacks={feedbacks}
            currentFeedbackIndex={currentFeedbackIndex}
            totalRecords={totalRecords}
            isLoadingMore={isLoadingMore}
          />
        </Stack>
      </Paper>
    </>
  );
};
